<template>
  <div class="header bgColorfff">
    <div class="header-wrap">
      <div style="display: flex;align-items: center">
        <img :src="anyuLogo" alt="" style="width:56px;height:42px;margin-right: 19px"/>
        <div style="color: #515151">
          <p style="font-size: 22px;letter-spacing: 7px;line-height:1.2">安预在线</p>
          <p style="font-size: 12px;letter-spacing: 2px">AN YU ONLINE</p>
        </div>
      </div>
      <el-menu
        :default-active="currentRouter"
        mode="horizontal"
        active-text-color="#3f61ff"
        :router="true"
        @select="handleSelect"
        class="el-menu-demo"
      >
        <el-menu-item index="/">
          <span class="header_nav_span">首页</span>
          <i class="el-menu-item_i"></i>
        </el-menu-item>
        <el-menu-item index="/abouts" style="margin-left: 42px">
          <span class="header_nav_span">关于我们</span>
          <i class="el-menu-item_i"></i>
        </el-menu-item>
        <el-menu-item index="/cooperation" style="margin-left: 42px">
          <span class="header_nav_span">合作中心</span>
          <i class="el-menu-item_i"></i>
        </el-menu-item>
        <!-- <el-menu-item index="3">在线学习</el-menu-item> -->
      </el-menu>
    </div>
  </div>
</template>

<script>
import AnyuLogo from "@/assets/anyulogo.png"
export default {
  name: "Header",
  data() {
    return {
      anyuLogo: AnyuLogo,
      activeIndex: "1",
      //背景透明不透明
      mainIndex: 0,
      currentRouter: "/",
      userLogin: false
    };
  },
  components: {},
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      if (key == "/Login") {
        this.mainIndex = 1;
        console.log("首页", this.mainIndex);
      } else {
        this.mainIndex = 0;
      }
    }
  },

  watch: {
    $route: function(to, from) {
      console.log("to", to.path);
      console.log("from", from.path);
      // if (to.path == "/TrainDetail") {
      //   this.currentRouter = "/Training";
      // } else if (to.path == "/CourseDetail") {
      //   this.currentRouter = "/OpenClass";
      // } else if (to.path == "/LiveDetail") {
      //   this.currentRouter = "/LiveContent";
      // } else if (to.path == "/JournDetail") {
      //   this.currentRouter = "/Journalism";
      // } else {
         this.currentRouter = to.path;
      // }
    }
  },
  beforeMount() {
    this.currentRouter = this.$route.path;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header_nav_span {
  display: inline-block !important;
  height: 51px !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0;
}
.header {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 84px;
  box-shadow: 0px 0px 12px 1px rgba(63, 97, 255, 0.19);
  margin-bottom: 60px;
  display: flex;
  align-items: center;
}
.bgColorfff {
  background-color: rgba(255, 255, 255);
}
.transparent {
  background-color: transparent;
}
.header-wrap {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
}
.header-search {
  width: 165px;
  height: 32px;
  line-height: 32px;
  padding-left: 13px;
  margin-top: 12px;
  box-sizing: border-box;
  /* border: 1px solid rgba(255, 255, 255, 1); */
  border: 1px solid #6e747e;
  border-radius: 16px;
  position: relative;
}
.header-wrap .el-menu-item {
  border: 0px !important;
}
.el-menu--horizontal > .el-menu-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 24px;
}
.el-menu-item_i {
  display: inline-block;
  width: 22px;
  border-bottom: 2px solid transparent;
}
.el-menu--horizontal > .el-menu-item.is-active .el-menu-item_i {
  border-bottom: 4px solid #3f61ff;
  border-radius: 2px;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue